interface IConfig {
  basename?: string;
  baseURI?: string;
}

const config: IConfig = {
  basename: process.env.REACT_APP_BASE_NAME,
  baseURI: process.env.REACT_APP_API_BASE_URI,
};

export default config;
